import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";
import {ANALYTICS} from "../../../third-party-services/analytics/analytics-consts";
import {APP, GAME_STATUSES} from "../../app/consts";
import {PREDICTION_WIDGET} from "../../../widgets/prediction-widget/predictions-widget.consts";
import {ROUTE_NAMES} from "../../consts";

export class MarketNavigationClickEvent extends ClickEvent {
  gameId: Number;
  competitionId: Number;
  status: GAME_STATUSES;
  currentLinkModelName: ROUTE_NAMES;
  marketType: Number;
  nextMarketType: Number;
  hasOdds: Boolean;
  clickDirection: PREDICTION_WIDGET.ANALYTICS.DIRECTIONS;

  constructor(params: MarketNavigationClickEvent) {
    super('click', 'mrkt-nav', 'prediction');

    this.currentLinkModelName = params.currentLinkModelName;
    this.gameId = params.gameId;
    this.competitionId = params.competitionId;
    this.status = params.status;
    this.marketType = params.marketType;
    this.nextMarketType = params.nextMarketType;
    this.hasOdds = params.hasOdds;
    this.clickDirection = params.clickDirection;
  }

  get properties() {
    const properties = super.properties;

    properties.gameId = this.gameId;
    properties.source = APP.ANALYTICS.SOURCES[this.currentLinkModelName];
    properties.status = ANALYTICS.GAME_STATUSES[this.status];
    properties.competitionId = this.competitionId;
    properties.marketType = this.marketType;
    properties.nextMarketType = this.nextMarketType;
    properties.isOdds = this.hasOdds;
    properties.clickDirection = this.clickDirection;

    return properties;
  }
}
